import React, { useState, useEffect, useMemo } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'
import { numberThousandSeparator } from '../../../utils/formatterUtil'

export default function PerformanceStepChart({
  legendData = [],
  seriesData = [],
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  // console.log('PerformanceStepChart -> legendData', legendData)
  // console.log('PerformanceStepChart -> seriesData', seriesData)

  const funnelData = useMemo(() => {
    return [...seriesData].reverse()
  }, [])

  const optionChart = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c}%',
    },
    legend: {
      data: legendData,
    },
    series: [
      {
        name: '',
        type: 'funnel',
        left: '10%',
        top: 60,
        bottom: 60,
        width: '80%',
        min: 0,
        max: 100,
        minSize: '0%',
        maxSize: '100%',
        // sort: 'descending',
        sort: 'none',
        gap: 2,
        label: {
          show: true,
          position: 'inside',
        },
        labelLine: {
          length: 10,
          lineStyle: {
            width: 1,
            type: 'solid',
          },
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
        },
        emphasis: {
          label: {
            fontSize: 20,
          },
        },
        data: funnelData || [],
      },
    ],
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts
        option={chartOption}
        style={{ height: '400px', width: '100%' }}
        className={'react_for_echarts'}
        onEvents={onEvents}
      />
    </div>
  )
}
